// DeletedTombstone.tsx — shared "Deleted by author" banner for PostCard + HeroPostCard.
// Body stays visible elsewhere on the card; this is just the note, sized per variant.
import styled from 'styled-components';
import { Icon } from '@/icons';

export interface DeletedTombstoneProps {
  size?: 'md' | 'lg';
}

const Root = styled.div<{ $lg: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: ${({ $lg }) => ($lg ? '12px 16px' : '10px 14px')};
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  background: ${({ theme }) => theme.color.glassBg};
  color: ${({ theme }) => theme.color.textMuted};
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme, $lg }) => ($lg ? theme.fontSize.md : theme.fontSize.sm)};
  font-style: italic;
`;

export function DeletedTombstone({ size = 'md' }: DeletedTombstoneProps) {
  return (
    <Root aria-label="Deleted by author" $lg={size === 'lg'}>
      <Icon name="trash" size={size === 'lg' ? 18 : 16} />
      Deleted by author. Interactions are off.
    </Root>
  );
}
